import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../../../constants/common'
import { RENTAL_LISTING_DOCUMENTS_ENTITY } from '../../../../../constants/entity'
import { FILE_SCOPE_RENTAL_LISTING } from '../../../../../constants/file'
import {
  getDocumentsItemActions,
  getDocumentsMassActions,
} from '../../../../Document'
import { EntityTabDocuments } from '../../../../EntityTab'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'

import {
  LISTING_PROFILE_DOCUMENTS_BREADCRUMB_LISTING,
  QA_NAME_LISTING_PROFILE_DOCUMENTS_TABLE,
} from './RentalPortalListingProfileDocuments.constants'
import { getListingProfileDocumentsRootBreadcrumbs } from './RentalPortalListingProfileDocuments.utils'

function RentalPortalListingProfileDocuments() {
  const { t } = useTranslation()

  const { handleEntityReload, listingData, registerDocumentsTabReload } =
    useListingProfileContext()

  return (
    <EntityTabDocuments
      breadcrumbRootItems={getListingProfileDocumentsRootBreadcrumbs({
        listingData,
        t,
      })}
      breadcrumbStorageItemId={LISTING_PROFILE_DOCUMENTS_BREADCRUMB_LISTING}
      entity={RENTAL_LISTING_DOCUMENTS_ENTITY}
      // TODO: drop once the backend rental-portal branch is merged: qa has no rental_listing scope and a scoped download returns 500.
      getDownloadApiParams={EMPTY_FUNCTION}
      getItemActions={getDocumentsItemActions}
      getMassActions={getDocumentsMassActions}
      objectId={listingData?.id}
      qaNameTable={QA_NAME_LISTING_PROFILE_DOCUMENTS_TABLE}
      rootDirectoryId={listingData?.directory_id}
      scope={FILE_SCOPE_RENTAL_LISTING}
      onLoadCounters={handleEntityReload}
      onRegisterReload={registerDocumentsTabReload}
    />
  )
}

export default RentalPortalListingProfileDocuments
